import { Widget } from 'jamespot-front-business';
import { WidgetWrapperProps } from 'jamespot-user-api';

import { useIntl } from 'react-intl';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';
import WidgetWrapperCore from '../widgets/WidgetWrapperCore';
import { CSSCommentsBlocWidgetWrapper } from './CommentsBloc.styles';

const JRCMessage = commonComponentsRegistry.getLazyComponent('Message');

export const CommentsBlocAddCommentWidgetsWrapper = ({ widgets }: { widgets: WidgetWrapperProps[] }) => {
    const intl = useIntl();
    const flushedWidgets = useAppSelector(Widget.selectors.selectFlushedWidgets, shallowEqual);

    return (
        <>
            {widgets
                .filter((el) => !flushedWidgets.includes(el.widget.uniqid))
                .map(
                    (widget) =>
                        widget &&
                        widget.widget && (
                            <CSSCommentsBlocWidgetWrapper key={widget.widget.uniqid}>
                                <WidgetWrapperCore
                                    uniqid={widget.widget.uniqid}
                                    widget={widget}
                                    inplace
                                    mode={'edit'}
                                    cannotDisplayComponent={(widget) => (
                                        <JRCMessage
                                            variant={'info'}
                                            message={intl.formatMessage({ id: 'WIDGET_Cannot_Display' }, { widget })}
                                        />
                                    )}
                                    context={'comment'}
                                />
                            </CSSCommentsBlocWidgetWrapper>
                        ),
                )}
        </>
    );
};
